// https://confluence.check24.de/display/HOULI/Release+Calendar
const ULI_VERSION_INT_DE = 'current';
const ULI_VERSION_INT_AT = 'current';
const ULI_VERSION_INT_ES = 'current';

const deviceOutput = window.TCMS.viewtype;
const uliEnvironmentMapping = {
    dev: 'int',
    int: 'int',
    staging: 'test',
    production: 'prod'
};

const ULI_LAYER_CONFIG = {
    deviceoutput: deviceOutput,
    api_product: '',
    login_email: '',
    login_phone: '',
    login_type: '',
    social_login_callback_url: encodeURIComponent(window.location.href),
    social_login_closing_url: '',
    social_login_base_url: ''
};

switch (window.TCMS.product) {
case 'fewo':
    ULI_LAYER_CONFIG.api_product = 'holidayflat';
    break;
case 'flug':
    ULI_LAYER_CONFIG.api_product = 'flight';
    ULI_LAYER_CONFIG.social_login_closing_url = encodeURIComponent('https://flug.check24.de/closing');
    break;
case 'hotel':
case 'hotel_at':
case 'hotel_es':
    ULI_LAYER_CONFIG.api_product = 'hotel';
    break;
case 'mietwagen_es':
case 'mietwagen_at':
case 'mietwagen':
    ULI_LAYER_CONFIG.api_product = 'rentalcar';
    break;
case 'urlaub_at':
case 'urlaub':
    ULI_LAYER_CONFIG.api_product = 'package';
    break;
case 'camper':
    ULI_LAYER_CONFIG.api_product = 'camper';
    break;
case 'cmx':
    ULI_LAYER_CONFIG.api_product = 'dersncmx';
}

switch (TCMS.language) {
case 'at':
    ULI_LAYER_CONFIG.social_login_base_url = encodeURIComponent(
        deviceOutput === 'mobile' ? 'https://m.check24.at/kundenbereich' : 'https://kundenbereich.check24.at'
    );
    break;
case 'de':
default:
    ULI_LAYER_CONFIG.social_login_base_url = encodeURIComponent(
        deviceOutput === 'mobile' ? 'https://m.check24.de/kundenbereich' : 'https://kundenbereich.check24.de'
    );
    break;
}

if (Check24.uliloginlayer) {
    // https://confluence.check24.de/display/HOULI/Login+Layer
    let environment = uliEnvironmentMapping[window.TCMS.env] || 'prod';

    // there is no template for the current version on integration
    // https://anmelden.check24-int.de/20220829-1/iframe/desktop/login/?api_product=flight&deviceoutput=desktop&login_email=&login_phone=&login_type=&password_reset_type=tan&password_reset_ref=&social_login_callback_url=&social_login_closing_url=&social_login_base_url=&points=false&custom_param=&transaction_type=none&browserback=&anonymous=false&responsive=false&main_width=&help_width=&border=none&background=&context=loginlayer&mode=&register_type=&transfer_token=440cc8f9-7f5d-43d0-b54f-2eac22d325dd
    if (environment === 'int' && TCMS.language === 'de') {
        Check24.uliloginlayer.config.version = ULI_VERSION_INT_DE;
    }

    if (environment === 'int' && TCMS.language === 'at') {
        Check24.uliloginlayer.config.version = ULI_VERSION_INT_AT;
    }

    if (environment === 'int' && TCMS.language === 'es') {
        Check24.uliloginlayer.config.version = ULI_VERSION_INT_ES;
    }

    Check24.uliloginlayer.config.env = environment;
}

export { ULI_LAYER_CONFIG, ULI_LAYER_CONFIG as default };
